import React from "react";
import { Link } from "react-router-dom";
import { M } from "./tokens";
import { PROOF } from "./machines";

/* One section, one job: this is a real brand, here is the proof, go touch it.
   No em dashes. */

const COUNT = [
  ["50/wk", "new ads in the account"],
  ["31", "split tests logged"],
  ["5", "pages and flows rebuilt here"],
  ["1,571", "verified reviews"],
];

const LINKS = [
  ["/axos", "Landing"],
  ["/axos/quiz", "Quiz"],
  ["/axos/advertorial", "Advertorial"],
  ["/axos/listicle", "Listicle"],
  ["/axos/emails", "Emails"],
];

export default function AxosIntro() {
  return (
    <section className="border-y" style={{ borderColor: M.border, background: M.bg }} data-snap data-testid="axos-intro">
      <div className="mx-auto w-full max-w-[1280px] px-5 py-16 sm:px-8 sm:py-24">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          <div>
            <div className="f-mono mb-4 text-[10px] uppercase tracking-[0.22em]" style={{ color: M.ok }}>
              Proof, not a case study
            </div>
            <h2 className="f-grotesk max-w-[20ch] text-[30px] font-bold leading-[1.04] tracking-[-0.03em] sm:text-[46px]">
              Everything below was built for one real brand.
            </h2>
            <p className="mt-6 max-w-[52ch] text-[15px] leading-[1.8]" style={{ color: M.muted }}>
              Axos sells thyroid and gut supplements at ibdassist.com. Every ad, page, quiz and email on this site came out
              of that one account. Nothing is a mockup.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {COUNT.map(([v, l]) => (
                <div key={l} className="rounded-xl border p-3.5" style={{ borderColor: M.border, background: M.surface }}>
                  <div className="f-grotesk tnum text-[21px] font-bold" style={{ color: M.ok }}>
                    {v}
                  </div>
                  <div className="f-mono mt-1 text-[8.5px] uppercase leading-[1.5] tracking-[0.1em]" style={{ color: M.dim }}>
                    {l}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-3 gap-2 sm:grid-cols-5">
              {LINKS.map(([to, label]) => (
                <Link
                  key={to}
                  to={`${to}?tests=1`}
                  data-testid={`axos-link-${to.split("/").pop()}`}
                  className="focus-ring f-mono rounded-full px-2 py-2 text-center text-[10px] uppercase tracking-[0.1em]"
                  style={{ color: M.ink, border: `1px solid ${M.border}`, background: M.surface2 }}
                >
                  {label}
                </Link>
              ))}
            </div>
            <p className="f-mono mt-3 text-[9.5px] uppercase tracking-[0.14em]" style={{ color: M.dim }}>
              Every page opens with a toggle that shows what we tested on it
            </p>

            <a
              href={PROOF.url}
              target="_blank"
              rel="noreferrer"
              data-testid="proof-link"
              className="focus-ring f-mono mt-8 inline-block rounded px-6 py-3.5 text-[10.5px] font-semibold uppercase tracking-[0.14em]"
              style={{ background: M.ok, color: "#04170F" }}
            >
              Open the live store
            </a>
          </div>

          <div className="grid grid-cols-2 gap-3.5 self-center">
            {[
              [PROOF.system, "The bundle", "col-span-2"],
              [PROOF.hashi, "Thyroid formula", ""],
              [PROOF.gut, "Gut formula", ""],
            ].map(([src, label, span]) => (
              <div
                key={label}
                className={`overflow-hidden rounded-2xl border ${span}`}
                style={{ borderColor: M.border, background: M.surface }}
              >
                <div
                  className="flex items-center justify-center p-4"
                  style={{ background: "radial-gradient(60% 60% at 50% 30%, rgba(95,227,161,0.10), transparent 70%)" }}
                >
                  <img src={src} alt={label} loading="lazy" className="max-h-[180px] w-full object-contain" />
                </div>
                <div className="f-mono border-t px-4 py-2.5 text-[9px] uppercase tracking-[0.14em]" style={{ borderColor: M.border, color: M.dim }}>
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
